@if (items?.length) {
	<p-splitButton [label]="default.label" [icon]="default.icon" (onClick)="default.command({originalEvent: $event})"
		[model]="items"></p-splitButton>
}
